export default "__VITE_ASSET__DNmnXYC7__";